import { Stack } from "PFComponents/containers";
import { Activity } from "PFTypes";

import { Assignee } from "./assignee";
import { Owners } from "./owners";

type ParticipantsProps = {
  activity: Activity;
};

export const Participants = ({ activity }: ParticipantsProps) => (
  <Stack gap="spacingMd">
    <Owners activity={activity} />
    <Assignee activity={activity} />
  </Stack>
);
